'use strict';

function SalaryNavigationController(salaryService, $route) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.isCurrent = isCurrent;

  function $onInit() {
    vm.urls = {
      invite: salaryService.urls.invite.base({ round: $route.current.params.round }),
      basis: salaryService.urls.basis.base({ round: $route.current.params.round }),
      distribution: salaryService.urls.distribution.base({ round: $route.current.params.round })
    };
  }

  function isCurrent(route) {
    return $route.current.regexp.test((route || ' ').charAt(0) === '#' ? route.substring(1) : route);
  }
}

module.exports = SalaryNavigationController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-navigation/salary-navigation.controller.js
 ** module id = 236
 ** module chunks = 0
 **/